import './FiRecaptcha.scss';

import * as angular from 'angular';
import { FiRecaptchaService } from '../../services/Recaptcha';

import { Component } from '../Component';

// "I'm not a robot" checkbox: <fi-recaptcha token="vm.recaptchaToken"></fi-recaptcha>
// While the box is ticked, token holds the reCAPTCHA token that the server verifies
@Component({
    controllerAs: 'vm',
    bindings: {
        token: '=',
    },
})
export class FiRecaptcha {
    static $inject = [
        '$element',
        '$scope',
        'fiRecaptchaService',
    ];

    constructor(
        private $element: angular.IAugmentedJQuery,
        private $scope: angular.IScope,
        private recaptcha: FiRecaptchaService,
    ) {
    }

    token: string;

    $postLink() {
        this.recaptcha.render(
            this.$element[0],
            (token) => this.$scope.$applyAsync(() => this.token = token),
            () => this.$scope.$applyAsync(() => this.token = null),
        ).catch(angular.noop);
    }
}
